// Each whitespace-separated term is wrapped in double quotes so Shopify
// treats it as an exact-token phrase rather than a fuzzy substring match.
// The configured scope (e.g. tag:検索対象) is prepended to every query.
function buildSearchQuery(terms, scope) {
  const quotedTerms = terms
    .trim()
    .split(/\s+/)
    .map(function (term) {
      return term.replace(/"/g, '')
    })
    .filter(Boolean)
    .map(function (term) {
      return '"' + term + '"'
    })
    .join(' ')
  return (scope || '') + (quotedTerms ? ' ' + quotedTerms : '')
}

function scopeSearchSubmit(form) {
  const hidden = form.querySelector('input[name="q"]')
  const input = form.querySelector('[data-search-input]')
  if (hidden && input) {
    hidden.value = buildSearchQuery(input.value, form.dataset.scope)
  }
}
